import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { TabSetsLevels } from "../../../ui";
import { joiningRequestStatuses } from "./constants";

const ApplicantsStatusTabs = ({ labels, summary, value, onChange, enabledStatuses }) => {
  const tabs = useMemo(() => {
    const statuses = enabledStatuses?.length
      ? enabledStatuses
      : Object.values(joiningRequestStatuses);

    return statuses.map((status) => ({
      value: status,
      label: (
        <span className="event-applicants__tab-label">
          <span>{labels[status]}</span>
          {status === joiningRequestStatuses.pending ? (
            <span className="event-applicants__count">
              {summary[status] || 0}
            </span>
          ) : null}
        </span>
      ),
    }));
  }, [enabledStatuses, labels, summary]);

  return <TabSetsLevels tabs={tabs} value={value} onChange={onChange} />;
};

ApplicantsStatusTabs.propTypes = {
  labels: PropTypes.object.isRequired,
  summary: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  enabledStatuses: PropTypes.arrayOf(PropTypes.string),
};

export default ApplicantsStatusTabs;
